import { post, defaultPost } from '../../../model/post';

export interface IState {
  posts: Array<post>;
  postsent: Array<post>;
  post: post;
  loadingposts: boolean;
}

export const DefaultState = (): IState => ({
  posts: [],
  post: defaultPost(),
  postsent: [],
  loadingposts: false,
})
